import { IReceberDadosGuiaRecolhimento, IReceberListagemGuiasRecolhimento } from 'interfaces/IGuiaRecolhimento';
import { IIdentificacaoBasica } from 'interfaces/IIdentificacaoBasica';
import { IProcessoMinerario } from 'interfaces/IProcessoMinerario';
import { ITipoDeUsoLista } from 'interfaces/ITipodeUso';
import { useApiClient } from '../../../hooks/useApiClient';

export const useBackEndRequests = () => {
  const httpCall = useApiClient();

  const getIdentificacaoBasica = async (cpfCnpj: string) => {
    const resposta = await httpCall.get<IIdentificacaoBasica>(`/arrecadacao/api/declarante/${cpfCnpj}`);

    return resposta.data;
  };

  const getListaGuiasRecolhimento = async (filtros: string, page: number, size: number, ordenacao: string) => {
    const resposta = await httpCall.get<IReceberListagemGuiasRecolhimento>(
      `/arrecadacao/api/guia-recolhimento/busca-paginada?page=${page}&size=${size}&filtros=${filtros}&ordenacao=${ordenacao}`
    );

    return resposta.data;
  };

  const exportarGuiasCSV = async (filtros: string, page: number, size: number, ordenacao: string) => {
    const resposta = await httpCall.get<Blob>(
      `/arrecadacao/api/guia-recolhimento/gerar-csv?page=${page}&size=${size}&filtros=${filtros}&ordenacao=${ordenacao}`,
      {
        responseType: 'blob',
      }
    );
    return resposta;
  };

  const exportarGuiasExcel = async (filtros: string, page: number, size: number, ordenacao: string) => {
    const resposta = await httpCall.get<Blob>(
      `/arrecadacao/api/guia-recolhimento/gerar-excel?page=${page}&size=${size}&filtros=${filtros}&ordenacao=${ordenacao}`,
      {
        responseType: 'blob',
      }
    );
    return resposta;
  };

  const getProcessoMinerarioPorNumero = async (numeroProcesso: string) => {
    const resposta = await httpCall.get<IProcessoMinerario>(`/arrecadacao/api/processo-minerario/${numeroProcesso}`);

    return resposta.data;
  };

  const getListaProcessoPorCpfCnpj = async (cpfCnpj: string, mesExercicio: number, anoExercicio: number) => {
    const resposta = await httpCall.get<string[]>(
      `/arrecadacao/api/processo-minerario/titular-arrendatario/outros-regimes/${cpfCnpj}/mes-exercicio/${mesExercicio}/ano-exercicio/${anoExercicio}`
    );
    return resposta.data;
  };

  const getDadosRecolhimento = async (idGuiaRecolhimento: string) => {
    const resposta = await httpCall.get<IReceberDadosGuiaRecolhimento>(
      `/arrecadacao/api/guia-recolhimento/${idGuiaRecolhimento}`
    );
    return resposta.data;
  };

  const getNcmPorGuiaRecolhimento = async (idGuiaRecolhimento: string) => {
    const resposta = await httpCall.get<string>(
      `/arrecadacao/api/ncm/por-substancia?guiaRecolhimentoId=${idGuiaRecolhimento}`
    );
    return resposta.data;
  };

  const getUnidadesMedidaPorGuiaRecolhimento = async (idGuiaRecolhimento: string) => {
    const resposta = await httpCall.get<string[]>(
      `/arrecadacao/api/unidade-medida/guia-de-recolhimento/${idGuiaRecolhimento}`
    );
    return resposta.data;
  };

  const deleteGuiaRecolhimento = async (idGuiaRecolhimento: string) => {
    await httpCall
      .delete(`/arrecadacao/api/guia-recolhimento/${idGuiaRecolhimento}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getIsPadraoAguaMineral = async (idGuiaRecolhimento: string) => {
    const resposta = await httpCall.get<boolean>(
      `/arrecadacao/api/substancia/isPadraoAguaMineral/${idGuiaRecolhimento}`
    );
    return resposta.data;
  };

  const getTiposDeUso = async (idGuiaRecolhimento: string) => {
    const resposta = await httpCall.get<ITipoDeUsoLista>(
      `/arrecadacao/api/guia-recolhimento/listar-tipos-uso/${idGuiaRecolhimento}`
    );
    return resposta.data;
  };

  return {
    getIdentificacaoBasica,
    getListaGuiasRecolhimento,
    exportarGuiasCSV,
    exportarGuiasExcel,
    getProcessoMinerarioPorNumero,
    getListaProcessoPorCpfCnpj,
    getDadosRecolhimento,
    getNcmPorGuiaRecolhimento,
    getUnidadesMedidaPorGuiaRecolhimento,
    deleteGuiaRecolhimento,
    getIsPadraoAguaMineral,
    getTiposDeUso,
  };
};
